<template>
  <div class="detail-container">
    <el-button @click="$router.back()">返回订单列表</el-button>
    <el-card v-loading="loading" :loading-text="'加载中...'">
      <!-- 订单基本信息 -->
      <el-descriptions title="订单基本信息" :column="2" border>
        <el-descriptions-item label="订单 ID">{{ order.order_id }}</el-descriptions-item>
        <el-descriptions-item label="订单编号">{{ order.order_number }}</el-descriptions-item>
        <el-descriptions-item label="客户名称">{{ customerName }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <el-tag :type="getStatusType(order.status)">{{ order.status }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="开单时间">{{ formatDateTime(order.order_time) }}</el-descriptions-item>
        <el-descriptions-item label="配送时间">{{ formatDateTime(order.delivery_time) }}</el-descriptions-item>
        <el-descriptions-item label="合计金额" :span="2">
          <span style="font-size: 18px; font-weight: bold; color: #f56c6c;">
            ¥ {{ order.total_amount?.toFixed(2) || '0.00' }}
          </span>
        </el-descriptions-item>
      </el-descriptions>

      <!-- 商品明细 -->
      <div style="margin-top: 30px;">
        <h3>商品明细</h3>
        <el-table :data="order.items" border style="width: 100%">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="merchandise_name" label="商品名称" min-width="150"></el-table-column>
          <el-table-column prop="specification" label="商品规格" width="120"></el-table-column>
          <el-table-column prop="quantity" label="数量" width="100" align="right">
            <template #default="scope">
              {{ scope.row.quantity }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单价" width="120" align="right">
            <template #default="scope">
              ¥ {{ scope.row.price?.toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="金额" width="120" align="right">
            <template #default="scope">
              ¥ {{ scope.row.amount?.toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 操作按钮 -->
      <div style="text-align: right; margin-top: 20px;">
        <el-button type="primary" @click="handlePrint">打印订单</el-button>
        <el-button type="danger" @click="handleDelete">删除订单</el-button>
      </div>
    </el-card>

    <!-- 打印区域（隐藏） -->
    <!-- <div v-if="order.order_id" ref="printAreaRef" id="printArea" style="display: none;">
      <div class="print-header">
        <h2>销售订单</h2>
        <p>订单编号: {{ order.order_number }}</p>
      </div>
      <div class="print-info">
        <p>客户: {{ customerName }}</p>
        <p>开单时间: {{ formatDateTime(order.order_time) }}</p>
        <p>配送时间: {{ formatDateTime(order.delivery_time) }}</p>
        <p>订单状态: {{ order.status }}</p>
      </div>
      <table class="print-table" border="1" style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th>序号</th>
            <th>商品名称</th>
            <th>规格</th>
            <th>数量</th>
            <th>单价</th>
            <th>金额</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in order.items" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.merchandise_name }}</td>
            <td>{{ item.specification || '-' }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.price?.toFixed(2) }}</td>
            <td>{{ item.amount?.toFixed(2) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5" style="text-align: right; font-weight: bold;">合计金额:</td>
            <td style="font-weight: bold;">{{ order.total_amount?.toFixed(2) }}</td>
          </tr>
        </tfoot>
      </table>
      <div class="print-footer" style="margin-top: 30px;">
        <p>制单人: ___________</p>
        <p>客户签字: ___________</p>
      </div>
    </div> -->
    <div ref="printContainer" class="print-container"></div>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import ordersAPI from '@/api/orders'
import { buildOrderPrintHtml } from '@/utils/orderPrint.js'
export default {
  name: 'OrderDetailView',
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      order: {
        order_id: null,
        order_number: '',
        customer_id: null,
        customer_name: '',
        order_time: '',
        delivery_time: '',
        status: '',
        total_amount: 0,
        items: []
      },
      loading: false,
      customerName: ''
    }
  },
  created() {
    this.fetchOrderDetail()
  },
  methods: {
    // 数字转人民币大写
    numberToChineseMoney(num) {
      if (!num || isNaN(num)) return '零元整'
      num = parseFloat(num)
      const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
      const units = ['元', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿']
      const decUnits = ['角', '分']
      let result = ''
      const integer = Math.floor(num)
      const decimal = Math.round((num - integer) * 100)
      let intStr = integer.toString()
      for (let i = 0; i < intStr.length; i++) {
        const idx = parseInt(intStr[i])
        const pos = intStr.length - 1 - i
        result += digits[idx] + units[pos]
      }
      if (decimal > 0) {
        const jiao = Math.floor(decimal / 10)
        const fen = decimal % 10
        if (jiao > 0) result += digits[jiao] + decUnits[0]
        if (fen > 0) result += digits[fen] + decUnits[1]
      } else {
        result += '整'
      }
      return result
    },
    async fetchOrderDetail() {
      this.loading = true
      try {
        const response = await ordersAPI.inquireOrder(this.id)
        this.order = response
        this.customerName = this.order.customer_name || '未知客户'
      } catch (error) {
        console.error('获取订单详情失败:', error)
        ElMessage.error(error.response?.data?.message || '获取订单详情失败')
      } finally {
        this.loading = false
      }
    },
    async handleDelete() {
      try {
        await ElMessageBox.confirm(
          '确定要删除该订单吗？删除后数据不可恢复！',
          '删除确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
        await ordersAPI.deleteOrder(this.id)
        ElMessage.success('订单删除成功')
        this.$router.push('/orders')
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除订单失败:', error)
          ElMessage.error('删除订单失败')
        }
      }
    },
    handlePrint() {
      try {
        const printHtml = buildOrderPrintHtml(this.order)
        const printContainer = this.$refs.printContainer;
        printContainer.innerHTML = printHtml;
        printContainer.style.display = 'block';
        setTimeout(() => {
          window.print();
          printContainer.style.display = 'none';
          printContainer.innerHTML = '';
        }, 300);
      } catch (error) {
        console.error('详情页打印失败:', error);
        ElMessage.error('打印失败，请重试');
      }
    },
    // handlePrint() {
    //   try {
    //     const originalTitle = document.title;
    //     const printWindow = window.open('', '_blank');
    //     if (!printWindow) {
    //       ElMessage.error('浏览器拦截了打印窗口，请允许弹窗后重试');
    //       return;
    //     }
    //     // 调用公共函数生成打印html
    //     const printHtml = buildOrderPrintHtml(this.order)

    //     printWindow.document.write(printHtml);
    //     printWindow.document.close();
    //     printWindow.onload = () => {
    //       printWindow.focus();
    //       setTimeout(() => {
    //         printWindow.print();
    //         printWindow.onafterprint = () => {
    //           printWindow.close();
    //           document.title = originalTitle;
    //         };
    //       }, 300);
    //     };
    //   } catch (error) {
    //     console.error('详情页打印失败:', error);
    //     ElMessage.error('打印失败，请重试');
    //   }
    // },


    formatDateTime(dateTime) {
      if (!dateTime) return ''
      const date = new Date(dateTime)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(/\//g, '-')
    },
    getStatusType(status) {
      const statusMap = {
        '正常': 'primary',
        '已完成': 'success',
        '已取消': 'danger'
      }
      return statusMap[status] || 'info'
    }
  }
}
</script>


<style scoped>
.print-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background: #fff;
  padding: 20px;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: none;
  box-sizing: border-box;
}

@media print {
  body * {
    visibility: hidden !important;
  }

  .print-container,
  .print-container * {
    visibility: visible !important;
  }

  .print-container {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    display: block !important;
    width: 100% !important;
    height: auto !important;
    padding: 20px !important;
    background: #fff !important;
    border: none !important;
    box-shadow: none !important;
  }
}

.detail-container {
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

.el-button:first-child {
  margin-bottom: 20px;
}

.el-descriptions {
  border-radius: 16px;
  overflow: hidden;
}

.el-descriptions__title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #1e293b, #3b82f6);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  display: inline-block;
}

.el-descriptions__label {
  font-weight: 600;
  background-color: #f8fafc;
  width: 120px;
}

.el-descriptions__content {
  background-color: white;
}

.el-descriptions-item:last-child .el-descriptions__content {
  font-size: 20px;
  font-weight: bold;
  color: var(--danger-color);
  text-shadow: 0 0 2px rgba(239, 68, 68, 0.2);
}

h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 24px 0 16px;
  border-left: 4px solid var(--primary-color);
  padding-left: 12px;
}

.el-table {
  border-radius: 16px;
  overflow: hidden;
}

.el-table__row:hover>td {
  background-color: #fef9e3 !important;
}

.detail-container .el-card__body>div:last-child {
  margin-top: 24px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .detail-container {
    padding: 12px !important;
  }

  .el-descriptions {
    font-size: 12px;
  }

  .el-descriptions__label {
    width: 80px !important;
  }

  .el-descriptions__content {
    word-break: break-all;
  }

  .detail-container .el-card__body>div:last-child {
    flex-direction: column;
    align-items: stretch;
  }

  .el-button {
    width: 100%;
    margin: 0 !important;
  }

  .el-table {
    font-size: 12px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>